export const CLASSES = ["Play Group", "LKG", "UKG", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
export const SECTIONS = ["A", "B"];

export const classLabel = (c) => {
  if (c === "LKG" || c === "UKG" || c === "Play Group") return c;
  const n = parseInt(c, 10);
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};
